import React from 'react'
import PropTypes from 'prop-types'
import ButtonCard from 'Components/ButtonCard'
import { useLocation, useParams } from 'react-router-dom'

const data = [
    { link: '/crm/wholesale', title: 'Master' },
    { link: '/crm/wholesale/verified', title: 'Active Buyers' },
    { link: '/crm/wholesale/pending', title: 'Pending Approval Buyers' },
    { link: '/crm/wholesale/rejected', title: 'Rejected Buyers' },
    { link: '/crm/wholesale/blocked', title: 'Blocked Buyers' }
]

function MenuButton(props) {
    const location = useLocation();
    return (
        <div style={{ display: 'flex' }} >
            {data.map(v => (<ButtonCard
                key={v.link}
                link={v.link}
                title={v.title}
                lightBlue
                selected={location.pathname === v.link}
            />))}
        </div>
    )
}

MenuButton.propTypes = {}

export default MenuButton
